var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_2974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.5,
    width: 45,
    height: 45,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_2974)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "image_2",
    d: "M9.875 39.375C8.84375 39.375 7.96094 39.0078 7.22656 38.2734C6.49219 37.5391 6.125 36.6562 6.125 35.625V9.375C6.125 8.34375 6.49219 7.46094 7.22656 6.72656C7.96094 5.99219 8.84375 5.625 9.875 5.625H36.125C37.1562 5.625 38.0391 5.99219 38.7734 6.72656C39.5078 7.46094 39.875 8.34375 39.875 9.375V35.625C39.875 36.6562 39.5078 37.5391 38.7734 38.2734C38.0391 39.0078 37.1562 39.375 36.125 39.375H9.875ZM9.875 35.625H36.125V9.375H9.875V35.625ZM11.75 31.875H34.25L27.2188 22.5L21.5938 30L17.375 24.375L11.75 31.875Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.a8506745ed0781c2a1e75576eff82dba.svg";
export { ForwardRef as ReactComponent };